// Generated by Melange

import CardGridModuleCss from "./cardGrid.module.css";
import * as JsxRuntime from "react/jsx-runtime";

const css = CardGridModuleCss;

function CardGrid(Props) {
  let children = Props.children;
  return JsxRuntime.jsx("div", {
    children: children,
    className: css.root
  });
}

const card_grid_cover_art_sizes = "(max-width: 639px) calc((100vw - 12px) / 2), (max-width: 767px) 143px, (max-width: 1023px) 137.6px, (max-width: 1279px) 155.333px, (max-width: 1535px) 168px, 177.5px";

const make = CardGrid;

export {
  card_grid_cover_art_sizes,
  make,
}
/* css Not a pure module */
